import { cx } from '@emotion/css';
import { ReactNode } from 'react';

import { labelClassName, labelValueClassName, valueClassName } from './styles';

interface Props {
  className?: string;
  label: string;
  labelClassName?: string;
  value: ReactNode;
  valueClassName?: string;
}

const LabelValue = ({
  className,
  label,
  labelClassName: superLabelClassName,
  value,
  valueClassName: superValueClassName,
}: Props) => {
  return (
    <div className={cx(labelValueClassName, className)}>
      <span className={cx(labelClassName, superLabelClassName)}>{label}</span>
      <span className={cx(valueClassName, superValueClassName)}>{value}</span>
    </div>
  );
};

LabelValue.displayName = 'LabelValue';

export default LabelValue;
